import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { MapPopupComponent } from '../../current-voyages/pages/map-popup/map-popup.component';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-deactivate-popup',
  templateUrl: './deactivate-popup.component.html',
  styleUrls: ['./deactivate-popup.component.scss']
})
export class DeactivatePopupComponent {

  statusOptions = ['Active', 'Inactive'];

  reasonOptions: string[] = [
      'Drydock',
      'Redelivered',
      'Delivered back to charterer',
      'Others'
    ];

  selectedStatus: string | null = null;
  selectedReason: string | null = null;

  isClientSpecific: boolean = false;

  clientName: string = '';
  vesselName: string = '';
  imo: string = '';
  clientOptions:any
  shipNameSuggestions: any[] = [];
imoSuggestions: any[] = [];
username: any;

  constructor(
    private dialogRef: MatDialogRef<MapPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
  ) {
     this.clientOptions = data.clientOptions || [];
  }
ngOnInit() {
  this.username = localStorage.getItem('username');
  this.fetchAllVessels();
  this.loadClientOptions();
}
loadClientOptions() {
    if (!this.clientOptions) return;

    this.requestFormService.getClientList().subscribe({
      next: (res: any[]) => {
        this.clientOptions = res;
      },
      error: (err) => console.error('Client API error', err),
    });
  }
  onStatusChange(): void {
  this.selectedReason = null;
  this.otherReason = '';

  if (this.selectedStatus === 'Inactive') {
    this.reasonOptions = [
      'Drydock',
      'Redelivered',
      'Delivered back to charterer',
      'Others'
    ];
  } else if (this.selectedStatus === 'Active') {
    this.reasonOptions = [
      'Reactivated',
      'Operational',
      'Others'
    ];
  } else {
    this.reasonOptions = [
      'Drydock',
      'Redelivered',
      'Delivered back to charterer',
      'Others'
    ];
  }
}
otherReason: string = '';
  submitDateTime(confirmed: boolean): void {
    if (!confirmed) {
      this.dialogRef.close();
      return;
    }
    if (!this.isClientSpecific && (!this.selectedStatus || !this.selectedReason)) {
  this.toastr.info(ToasterMessages.FormValidation);
  return;
}

if (
  this.selectedReason === 'Others' &&
  !this.otherReason.trim()
) {
  this.toastr.info('Please enter reason');
  return;
}

    if (this.isClientSpecific && !this.clientName) {
      this.toastr.info('Please enter client name');
      return;
    }

    if (!this.isClientSpecific && (!this.vesselName || !this.imo)) {
      this.toastr.info('Please enter vessel name and IMO');
      return;
    }
    const proceed = confirm('Do you want to continue?');

  if (!proceed) {
    return;
  }
    const payload = {
      client_specific: this.isClientSpecific,
      client_name: this.clientName,
      vessel_name: this.vesselName,
      imo: this.imo,
      status: this.isClientSpecific ? 'Inactive' : this.selectedStatus,
      reason:
        this.selectedReason === 'Others'
          ? this.otherReason.trim()
          : this.selectedReason
        };

    console.log(payload);
    this.sharedDataService.toggleVesselStatus(payload).subscribe({
        next: (res) => {
          this.toastr.success('Updated successfully');
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.toastr.error('Failed to update status');
          console.error(err);
        }
      });
    this.dialogRef.close();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  onVesselNameChange(value: string): void {

  if (!value) {
    this.shipNameSuggestions = [];
    return;
  }

  value = value.toLowerCase();

  this.shipNameSuggestions = this.vessels.filter((v: any) =>
    v.vessel_name?.toLowerCase().includes(value)
  );
}

selectVessel(vessel: any): void {

  this.vesselName = vessel.vessel_name;
  this.imo = vessel.imo;

  this.shipNameSuggestions = [];
}

onImoChange(value: string): void {

  if (!value) {
    this.imoSuggestions = [];
    return;
  }

  this.imoSuggestions = this.vessels.filter((v: any) =>
    v.imo?.toString().includes(value)
  );
}

selectImo(vessel: any): void {

  this.imo = vessel.imo;
  this.vesselName = vessel.vessel_name;

  this.imoSuggestions = [];
}

 private vessels: any;
  fetchAllVessels() {
    this.sharedDataService.getLookerVessels(this.username).subscribe({
      next: (res: any) => {
        this.vessels = res || [];
      },
      error: (err) => {
        console.error('Failed to load vessels', err);
      },
    });
  }
}